import type { ApiContext } from "@/api/types";
import type {
  Assessment,
  AssessmentSubmissionBody,
  AssessmentSubmissionResponse,
  Task,
} from "@/core/types";
import { httpAuth2 } from "@/api/auth";

export const assessmentRequestsTyped = {
  get_definition: function ({
    assessmentId,
    context,
    version,
  }: {
    assessmentId: string;
    context?: ApiContext;
    version?: number;
  }): Promise<Assessment> {
    return httpAuth2
      .get(`/v1/assessment/get_definition/${assessmentId}`, {
        context,
        ...(version !== undefined && { searchParams: { version } }),
      })
      .json<Assessment>();
  },

  post_answer: function ({
    context,
    data,
  }: {
    context?: ApiContext;
    data: AssessmentSubmissionBody;
  }): Promise<AssessmentSubmissionResponse> {
    return httpAuth2
      .post("/v1/assessment/post_answer", { context, json: data })
      .json<AssessmentSubmissionResponse>();
  },

  skip_task: function ({ taskId }: { taskId: Task["task_id"] }): Promise<void> {
    return httpAuth2.post(`/v1/assessment/skip_task/${taskId}`).json<void>();
  },
};
